import Scene = Phaser.Scene;
import Text = Phaser.GameObjects.Text;
import {ResourceType} from "@/store/place/types";
import ResourceUtils from "@/utils/resource-utils";
import TextUtils from "@/utils/text-utils";
import {Keys} from "@/constants/key";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import TaskUtils from "@/utils/task-utils";

export class ResSubpanel extends Phaser.GameObjects.Container {

    private resType: ResourceType;
    private resText: Text | undefined;
    private balance!:number;

    constructor(scene: Scene, x: number, y: number, resType: ResourceType, value: number) {
        super(scene);

        this.scene = scene;
        this.x = 0;
        this.y = y;
        this.resType = resType;
        this.balance = value;

        const resBack = SpriteUtils.addSprite(this.scene, 0, 0, Keys.ATLAS_UI_2, Keys.UI2_RES).setOrigin(0, 0);

        let atlas = ResourceUtils.getResourceAtlasUi2(resType);
        let image = ResourceUtils.getResourceImageUi2(resType);
        const resIcon = SpriteUtils.addSprite(this.scene, CU.scale(-10) + ResSubpanel.iconShiftX(resType), -2 + ResSubpanel.iconShiftY(resType),
            atlas? atlas : image, atlas? image : undefined).setOrigin(0, 0);

        this.resText = TextUtils.addTextAdvanced(scene, ResSubpanel.getValueText(resType, value), 55, 23,
            '#fefefe', 13, 'normal', 80, 'center', 1, Fonts.MYRIADPRO_REGULAR);

        this.add([resBack, resIcon, this.resText]);
    }

    public setBalance(value: number) {
        this.balance = value;
        this.resText!.setText(ResSubpanel.getValueText(this.resType, value));
    }

    public getBalance(): number {
        return this.balance;
    }

    private static getValueText(key: ResourceType, value: number) {
        return key === ResourceType.MITHRIL ? String(value) : TextUtils.formatMoney(value);
    }

    private static iconShiftY(resType: ResourceType) {
        if (resType === ResourceType.MITHRIL) {
            return -2;
        } else if (resType === ResourceType.GOLD || resType === ResourceType.CRYSTAL) {
            return 1;
        } else if (resType === ResourceType.EVENT_CURRENCY) {
            // if(TaskUtils.isBirthdayHatTime() || TaskUtils.isIvanKupalaTime()){
            //     return 5;
            // } else if (TaskUtils.isAugustApplesTime()){
            //     return -5;
            // }
            // if (TaskUtils.isSeptemberCatsTime()){
            //     return -5;
            // }
            if (TaskUtils.isHalloweenTime()){
                return -5;
            }
        }
        return 0;
    }

    private static iconShiftX(resType: ResourceType) {
        if (resType === ResourceType.EVENT_CURRENCY) {
            // if(TaskUtils.isBirthdayHatTime() || TaskUtils.isIvanKupalaTime()){
            //     return 5;
            // } else if (TaskUtils.isAugustApplesTime()) {
            //     return -20;
            // }
            // if (TaskUtils.isSeptemberCatsTime()) {
            //     return -20;
            // }
            if (TaskUtils.isHalloweenTime()) {
                return -20;
            }
        }
        return 0;
    }

    public setOrigin(x: number, y: number): void {
        // do nothing
    }
}
